import React from 'react'
import cx from 'classnames'
import styles from './Notification.module.scss'
import CloseIcon from '../../atoms/Icons/Controls/Close'
import NotificationHeading from './NotificationHeading'
import NotificationBody from './NotificationBody'

export interface INotification {
  type: 'success' | 'info' | 'warning' | 'error'
  heading: string
  message: string
  onDismiss: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactElement
}

const Notification = (props: INotification) => {
  const { type, heading, message, onDismiss, children } = props
  const classNames = cx([styles.root, styles[type]])

  return (
    <div className={classNames}>
      <button className={styles.closeButton} onClick={onDismiss}>
        <CloseIcon />
      </button>
      {heading && <NotificationHeading>{heading}</NotificationHeading>}
      {message && (
        <NotificationBody>
          <p>{message}</p>
        </NotificationBody>
      )}
      {children}
    </div>
  )
}

export default Notification
